import base from "@/store/utils/api-route/base";

const customerAPI = {
	list: `${base.meta}list_outlet_sorting_meta`,
	detail: `${base.meta}detail_outlet_meta`
}

export default customerAPI